var map = {
	"./image_0.jpg": [
		813,
		813
	],
	"./image_1.jpg": [
		888,
		888
	],
	"./image_10.jpg": [
		490,
		490
	],
	"./image_2.jpg": [
		223,
		223
	],
	"./image_3.jpg": [
		554,
		554
	],
	"./image_4.jpg": [
		785,
		785
	],
	"./image_5.jpg": [
		412,
		412
	],
	"./image_6.jpg": [
		539,
		539
	],
	"./image_7.jpg": [
		14,
		14
	],
	"./image_8.jpg": [
		221,
		221
	],
	"./image_9.jpg": [
		40,
		40
	],
	"./logo192.png": [
		864
	],
	"./logo_battle.png": [
		869
	],
	"./logo_paddle.png": [
		803
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 161;
module.exports = webpackAsyncContext;